module.exports = __webpack_public_path__ + "img/1553276115.37dc06cb.jpg";